<!-- eslint-disable vue/no-v-html -->
<template>
    <div
        class="literal-element"
        v-html="literal" />
    <!-- eslint-enable vue/no-v-html -->
</template>

<script>
    import base from "./_elementBase";
    export default {
        extends: base,
        computed: {
            literal() {
                return this.element.Properties.literal;
            }
        }
    };
</script>

<style lang="scss" scoped>
    // the :deep selector is used to make sure that the tables
    // within literal-element are affected when using scoped styles
    .literal-element :deep(table) {
        width: 100%;
    }
</style>
